module.exports = __webpack_public_path__ + "static/media/Better_Weebly_Background.73959f90.gif";